var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.terms)?_c('div',{staticClass:"container pt-6"},[_c('vue-markdown-plus',{staticClass:"content"},[_vm._v(_vm._s(_vm.terms.body))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }